import React, { FC, useState, useEffect } from 'react'
import { IonPage, IonContent, useIonViewWillEnter, IonFooter } from '@ionic/react'
import { RouteComponentProps } from 'react-router-dom'
import { observer } from 'mobx-react'
import { orderMobx, storeMobx, cartMobx } from 'restaurant'
import i18n from 'i18next'
import { buyTogetherMobx, multiPersonMobx } from '@mobxStore'
import { keyBy } from '@dt/fe-utils/dist/lodash'
import { classNames, format } from '@dt/fe-utils'
import './index.scss'

interface IProps extends RouteComponentProps {
}

let isSend = false // 是否发送短信
let initCnt = 0
let st: any = null

const payIcon = {
  cn: 'icon-guoneizhifuchenggong2x',
  us: 'icon-fukuanlu',
  de: 'icon-deyuchenggong'
}

const Bill: FC<IProps> = ({ match }) => {
  const [isCheckPay, setIsCheckPay] = useState(true)
  const viewOrder = orderMobx.viewOrder
  const viewDetailList = orderMobx.viewDetailList
  // const viewDetailMap = orderMobx.viewDetailMap
  const { viewDetailMap, expressMap } = orderMobx
  const currentPersonId = multiPersonMobx.getCurrentPersonInfo()?.personId

  const getDelayOrder = (orderNo: string) => {
    orderMobx.init(orderNo, { isNoToken: true, showPingtanByMember: 1, showMember: 1, isBuyTogether: true }).then((orderDetail) => {
      initCnt += 1
      if (orderMobx.viewOrder.status === 'Paying' || orderMobx.viewOrder.status === 'Pending') {
        if (initCnt < 4) {
          st = setTimeout(() => getDelayOrder(orderNo), 300)
        } else {
          setIsCheckPay(false)
        }
      } else {
        setIsCheckPay(false)
        if (orderMobx.viewOrder.status === 'Success') {
          cartMobx.clearPart({ remark: '', person: 1, startTime: null, ordersId: '', managerDiscount: null })
        }
      }
    }).catch((err: any) => {
      console.log(err)
    })
  }

  useIonViewWillEnter(() => {
    const orderNo = location.pathname.split('/')[2]
    isSend = false
    initCnt = 0
    getDelayOrder(orderNo)
  })

  useEffect(() => {
    if (viewDetailList.length) {
      const memberMap = keyBy(viewDetailList, 'addUserId')
      const memberIdArr = Object.keys(memberMap).map(id => Number(id))
      buyTogetherMobx.getBulkAvatars(memberIdArr)
    }
  }, [viewDetailList])
  const getDetailItem = (detail) => {
    const addUserId = detail?.addUserId || 0
    const productsArr = detail?.products || []
    const express = expressMap[addUserId] || 0
    return (
      <div key={addUserId} className='bill-detail-item'>
        <div className='info'>
          <div className='name-wrap'>
            <img src={buyTogetherMobx.memberMap[addUserId]?.avatarUrl} alt='' />
            <div className='name'>{`${detail?.addUserName}${addUserId === currentPersonId ? '(我)' : ''}`}</div>
          </div>
          <div className='price'>{i18n.t('bill.buyTogether.needPay', { share: format.toPrice((detail?.box || 0) + express) })} <span>{format.toPrice((detail?.needPayNoExpress || 0) + express)}</span></div>
        </div>
        <div className='products'>
          {
            productsArr.map(item => {
              return (
                <div className={classNames('products-item', { 'single': productsArr.length === 1 })} key={`${addUserId}_${item.pk}`}>
                  <div className={classNames('products-item-base', { 'no-extend': !item.optionStr.length })}>
                    <p className='name'>{item.name}</p>
                    <div className='price'>{format.toPrice(item.realPriceWithTax)}</div>
                  </div>
                  <div className='products-item-extend'>
                    {!!item.optionHtml && <p dangerouslySetInnerHTML={{ __html: item.optionHtml }} />}
                  </div>
                </div>
              )
            })
          }
        </div>
      </div>
    )
  }

  return (
    <IonPage className='pay-bill-page bill-together'>
      <IonContent>
        <div className='pay-bill-content'>
          <div className='bill-top'>
            <div className='img-box' style={{ backgroundImage: `url(${storeMobx.brand.logo || Config.defaultImg.store})` }}></div>
            <p className='store-name'>{storeMobx.info.storeName}</p>
            <p className='price-total'>{format.toPrice(Number(viewOrder.totalPrice))}</p>
            <p className='price-detail'>{i18n.t('bill.buyTogether.needPayTotal', { product: format.toPrice(viewOrder.itemTotalPrice), box: format.toPrice(viewOrder.boxPrice), express: format.toPrice(viewOrder.expressPrice) })}</p>
            <p className='order-pay'>{i18n.t('bill.buyTogether.paidBy', { name: (orderMobx.order as any).memberInfo?.nickName })}</p>
            <p className='order-time'>{format.toDateTime(viewOrder.addTime)}</p>
          </div>
          <div className='bill-detail'>
            {
              viewDetailMap[currentPersonId] && getDetailItem(viewDetailMap[currentPersonId])
            }
            {
              Object.keys(viewDetailMap).map(user => {
                const detail = viewDetailMap[user]
                return (user !== currentPersonId ? getDetailItem(detail) : <></>)
              })
            }
          </div>
        </div>
      </IonContent>
      <IonFooter>
        <div className='btn-box'>
          <div className='btn btn-cancel' data-cypid='cancel-bt-bill' onClick={() => buyTogetherMobx.returnMenuPage('', true)}>返回</div>
        </div>
      </IonFooter>
    </IonPage>
  )
}

export default observer(Bill)
